import type { ICustomControlRequestReadProps } from '../../interfaces/customControlRequestReadProps';
import { SomnologyOrganizationType } from '../../../../../../common/enums/somnologyOrganizationType';
import { RequestSummaryKsyosMedicalCenter } from './RequestSummaryKsyosMedicalCenter';
import { RequestSummaryNsi } from './RequestSummaryNsi';

export function RequestSummary(props: ICustomControlRequestReadProps) {
    return (
        <>
            {props.request.customControlData.somnologyOrganizationType ===
                SomnologyOrganizationType.ksyosMedicalCenter && <RequestSummaryKsyosMedicalCenter {...props} />}

            {props.request.customControlData.somnologyOrganizationType === SomnologyOrganizationType.nsi && (
                <RequestSummaryNsi {...props} />
            )}
        </>
    );
}
